"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconColorThemes = void 0;
var react_1 = __importStar(require("react"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var IconColorThemes;
(function (IconColorThemes) {
    IconColorThemes["uiDark1"] = "uiDark1";
    IconColorThemes["default"] = "default";
    IconColorThemes["white"] = "white";
})(IconColorThemes = exports.IconColorThemes || (exports.IconColorThemes = {}));
var Cart = function (_a) {
    var _b = _a.color, color = _b === void 0 ? IconColorThemes.default : _b, size = _a.size, rest = __rest(_a, ["color", "size"]);
    var _c = (0, react_1.useState)(b2c_theme_1.colors.defaultIconColor), iconColor = _c[0], setIconColor = _c[1];
    var _d = (0, react_1.useState)(b2c_theme_1.defaultIconSize), iconSize = _d[0], setIconSize = _d[1];
    (0, react_1.useEffect)(function () {
        switch (color) {
            case IconColorThemes.white:
                setIconColor(b2c_theme_1.colors.white);
                break;
            case IconColorThemes.uiDark1:
                setIconColor(b2c_theme_1.colors.iconUiDark1);
                break;
            default:
                setIconColor(b2c_theme_1.colors.defaultIconColor);
        }
    }, [color]);
    (0, react_1.useEffect)(function () {
        switch (size) {
            case b2c_theme_1.IconSizes.xSmall:
                setIconSize(b2c_theme_1.IconSizesPx.xSmall);
                break;
            case b2c_theme_1.IconSizes.small:
                setIconSize(b2c_theme_1.IconSizesPx.small);
                break;
            case b2c_theme_1.IconSizes.medium:
                setIconSize(b2c_theme_1.IconSizesPx.medium);
                break;
            case b2c_theme_1.IconSizes.large:
                setIconSize(b2c_theme_1.IconSizesPx.large);
                break;
            case b2c_theme_1.IconSizes.default:
                setIconSize(b2c_theme_1.defaultIconSize);
            default:
                setIconSize(b2c_theme_1.defaultIconSize);
        }
    }, [size]);
    var innerIcon = (0, react_1.useMemo)(function () {
        switch (iconSize) {
            case b2c_theme_1.IconSizesPx.xSmall:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_1043)" },
                        react_1.default.createElement("g", { clipPath: "url(#clip1_49_1043)" },
                            react_1.default.createElement("path", { "data-testid": "cart-icon", d: "M0.5 0.5H2.5V8.5H9.5L11.5 3.5H2.5", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                            react_1.default.createElement("path", { d: "M3 12C3.55228 12 4 11.5523 4 11C4 10.4477 3.55228 10 3 10C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12Z", fill: iconColor }),
                            react_1.default.createElement("path", { d: "M10 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12Z", fill: iconColor }))),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_1043" },
                            react_1.default.createElement("rect", { width: "12", height: "12", fill: "transparent" })),
                        react_1.default.createElement("clipPath", { id: "clip1_49_1043" },
                            react_1.default.createElement("rect", { width: "12", height: "12", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.small:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_978)" },
                        react_1.default.createElement("g", { clipPath: "url(#clip1_49_978)" },
                            react_1.default.createElement("path", { "data-testid": "cart-icon", d: "M0.5625 0.5625H3.9375V10.6875H15.1875L17.4375 2.8125H7.3125", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                            react_1.default.createElement("path", { d: "M4.5 17.4375C5.43198 17.4375 6.1875 16.682 6.1875 15.75C6.1875 14.818 5.43198 14.0625 4.5 14.0625C3.56802 14.0625 2.8125 14.818 2.8125 15.75C2.8125 16.682 3.56802 17.4375 4.5 17.4375Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                            react_1.default.createElement("path", { d: "M14.625 17.4375C15.557 17.4375 16.3125 16.682 16.3125 15.75C16.3125 14.818 15.557 14.0625 14.625 14.0625C13.693 14.0625 12.9375 14.818 12.9375 15.75C12.9375 16.682 13.693 17.4375 14.625 17.4375Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }))),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_978" },
                            react_1.default.createElement("rect", { width: "18", height: "18", fill: "transparent" })),
                        react_1.default.createElement("clipPath", { id: "clip1_49_978" },
                            react_1.default.createElement("rect", { width: "18", height: "18", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.medium:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_49_959)" },
                        react_1.default.createElement("path", { "data-testid": "cart-icon", d: "M6.5 23.5C7.05228 23.5 7.5 23.0523 7.5 22.5C7.5 21.9477 7.05228 21.5 6.5 21.5C5.94772 21.5 5.5 21.9477 5.5 22.5C5.5 23.0523 5.94772 23.5 6.5 23.5Z", fill: iconColor }),
                        react_1.default.createElement("path", { d: "M20.5 23.5C21.0523 23.5 21.5 23.0523 21.5 22.5C21.5 21.9477 21.0523 21.5 20.5 21.5C19.9477 21.5 19.5 21.9477 19.5 22.5C19.5 23.0523 19.9477 23.5 20.5 23.5Z", fill: iconColor }),
                        react_1.default.createElement("path", { d: "M6.5 23.5C7.05228 23.5 7.5 23.0523 7.5 22.5C7.5 21.9477 7.05228 21.5 6.5 21.5C5.94772 21.5 5.5 21.9477 5.5 22.5C5.5 23.0523 5.94772 23.5 6.5 23.5Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                        react_1.default.createElement("path", { d: "M20.5 23.5C21.0523 23.5 21.5 23.0523 21.5 22.5C21.5 21.9477 21.0523 21.5 20.5 21.5C19.9477 21.5 19.5 21.9477 19.5 22.5C19.5 23.0523 19.9477 23.5 20.5 23.5Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                        react_1.default.createElement("path", { d: "M1.5 1.5H4.5V15.5C4.5 16.0304 4.71071 16.5391 5.08579 16.9142C5.46086 17.2893 5.96957 17.5 6.5 17.5H22.5", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                        react_1.default.createElement("path", { d: "M4.5 5.5H21.5L19.5 13.5H4.5", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_49_959" },
                            react_1.default.createElement("rect", { width: "24", height: "24", fill: "transparent" })))));
            case b2c_theme_1.IconSizesPx.large:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("g", { clipPath: "url(#clip0_102_461)" },
                        react_1.default.createElement("path", { "data-testid": "cart-icon", d: "M11 60.5C14.0376 60.5 16.5 58.0376 16.5 55C16.5 51.9624 14.0376 49.5 11 49.5C7.96243 49.5 5.5 51.9624 5.5 55C5.5 58.0376 7.96243 60.5 11 60.5Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                        react_1.default.createElement("path", { d: "M54 60.5C57.0376 60.5 59.5 58.0376 59.5 55C59.5 51.9624 57.0376 49.5 54 49.5C50.9624 49.5 48.5 51.9624 48.5 55C48.5 58.0376 50.9624 60.5 54 60.5Z", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                        react_1.default.createElement("path", { d: "M4.5 4.5L9.5 10.5V34.5L4.5 43.5H60.5", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" }),
                        react_1.default.createElement("path", { d: "M9.5 10.5H56.5L48.5 34.5H9.5", stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round" })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("clipPath", { id: "clip0_102_461" },
                            react_1.default.createElement("rect", { width: "64", height: "64", fill: "transparent" })))));
        }
    }, [iconSize, iconColor]);
    return (react_1.default.createElement("svg", __assign({ width: iconSize, height: iconSize, viewBox: "0 0 ".concat(iconSize, " ").concat(iconSize), fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "cart-icon-container" }, rest), innerIcon));
};
exports.default = Cart;
//# sourceMappingURL=Cart.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/@urbanmassage/component-library/lib/Icons/Cart/Cart.js
// module id = 1275
// module chunks = 81